<template>
  <bubble-menu
    v-if="editor"
    :editor="editor"
    :tippy-options="{ duration: 100 }"
    class="bubble-menu"
  >
    <div class="bubble-menu-content">
      <button
        @click="executeCommand('toggleBold')"
        :class="{ active: isActive('bold') }"
        class="bubble-btn"
        title="Bold"
      >
        <strong>B</strong>
      </button>
      <button
        @click="executeCommand('toggleItalic')"
        :class="{ active: isActive('italic') }"
        class="bubble-btn"
        title="Italic"
      >
        <em>I</em>
      </button>
      <button
        @click="executeCommand('toggleUnderline')"
        :class="{ active: isActive('underline') }"
        class="bubble-btn"
        title="Underline"
      >
        <u>U</u>
      </button>
      <div class="bubble-separator"></div>
      <button
        @click="setLink"
        :class="{ active: isActive('link') }"
        class="bubble-btn"
        title="Link"
      >
        🔗
      </button>
      <button
        @click="executeCommand('toggleCode')"
        :class="{ active: isActive('code') }"
        class="bubble-btn"
        title="Code"
      >
        &lt;/&gt;
      </button>
    </div>
  </bubble-menu>
</template>

<script>
import { BubbleMenu } from '@tiptap/vue-2'

export default {
  name: 'EditorBubbleMenu',
  components: {
    BubbleMenu,
  },
  props: {
    editor: {
      type: Object,
      default: null
    }
  },
  methods: {
    executeCommand(command, options = {}) {
      this.$emit('execute-command', command, options)
    },
    
    isActive(name, attributes = {}) {
      if (!this.editor) return false
      return this.editor.isActive(name, attributes)
    },
    
    setLink() {
      const previousUrl = this.editor.getAttributes('link').href
      const url = window.prompt('URL', previousUrl)
      
      if (url === null) {
        return
      }
      
      if (url === '') {
        this.editor.chain().focus().extendMarkRange('link').unsetLink().run()
        return
      }
      
      this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
    }
  }
}
</script>

<style scoped>
.bubble-menu {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  padding: 4px;
}

.bubble-menu-content {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
}

.bubble-btn {
  background: white;
  border: 1px solid transparent;
  border-radius: 3px;
  padding: 4px 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  color: #374151;
}

.bubble-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.bubble-btn.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.bubble-separator {
  width: 1px;
  height: 16px;
  background: #e5e7eb;
  margin: 0 4px;
}
</style>